import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";
const db = getFirestore(firebaseApp);


export default function escribirLog(accion, item, autor) {
  // Crear fecha usando la fecha local del sistema
  const date = new Date();
  
  // Formatear la fecha en el mismo formato que antes
  const fecha = date.getDate().toString().padStart(2, '0') + "-" + 
      (date.getMonth() + 1).toString().padStart(2, '0') + "-" + 
      date.getFullYear() + "," + 
      date.getHours().toString().padStart(2, '0') + ":" + 
      date.getMinutes().toString().padStart(2, '0') + ":" + 
      date.getSeconds().toString().padStart(2, '0') + ":" + 
      date.getMilliseconds().toString().padStart(2, '0');

  // Grabamos el log directamente, sin depender de una API externa
  const collectionRef = collection(db, "logs");
  const docuRef = doc(collectionRef, fecha);
  const dato = {
    accion,
    fecha,
    item,
    autor,
  };
  
  // Devolver la promesa para manejar posibles errores donde se llama a la función
  return setDoc(docuRef, dato);
}